import ParagraphComponent from './Paragraph/Paragraph'
import FieldSetComponent from './FieldSet/FieldSet'
import TableComponent from './Table/Table'
import SectionComponent from './Section/Section'
import SubsectionComponent from './Subsection/Subsection'
import TextComponent from './Text/Text'
import DecisionComponent from './Decision/Decision'

export const Paragraph = ParagraphComponent
export const FieldSet = FieldSetComponent
export const Table = TableComponent
export const Section = SectionComponent
export const Subsection = SubsectionComponent
export const Text = TextComponent
export const Decision = DecisionComponent
